import {debounce} from 'throttle-debounce';  

export function events(){

	/*
	$("body").on("input propertychange change", "."+this.rangeInputClass, ()=>{

		return this.valueHasChanged({
			changedFrom: "slider"
		});

	});
	*/

	$("body").on("input propertychange change", "."+this.rangeInputClass, debounce(150, ()=>{

		return this.valueHasChanged({
			changedFrom: "slider"
		});

	}));	

	$("body").on("keyup", "."+this.editableInputClass, debounce(250, ()=>{

		return this.valueHasChanged({
			changedFrom: "input"
		});

	}));


	$("body").on("mousedown", "."+this.resetBtnClass, ()=>{

		$("."+this.rangeInputClass).val(this.defaultValue);

		return this.valueHasChanged({
			changedFrom: "slider"
		});		

	});

	

};